export default __webpack_public_path__ + "15ec9e9fd5b3b09817c02e6bcc9acf76.woff";